import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import './BetaChip.css';

const ELECTRIC_BLUE = '#00C2FF';

function hexToRgbString(hex) {
    const value = hex.replace('#', '');
    const bigint = parseInt(value, 16);
    return `${(bigint >> 16) & 255}, ${(bigint >> 8) & 255}, ${bigint & 255}`;
}

function BetaChip({ sx = {}, color = ELECTRIC_BLUE }) {
    const rgb = hexToRgbString(color);
    return (
        <Box
            style={{ '--beta-rgb': rgb }}
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.7,
                px: 1.1,
                py: 0.4,
                borderRadius: 999,
                bgcolor: 'rgba(var(--beta-rgb), 0.08)',
                border: '1px solid rgba(var(--beta-rgb), 0.35)',
                lineHeight: 1,
                flexShrink: 0,
                ...sx,
            }}
        >
            <Box
                className="beta-chip-dot"
                sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: color, flexShrink: 0 }}
            />
            <Typography
                sx={{
                    fontSize: '0.65rem',
                    fontWeight: 800,
                    letterSpacing: '0.08em',
                    color,
                    textTransform: 'uppercase',
                    lineHeight: 1,
                }}
            >
                Beta
            </Typography>
        </Box>
    );
}

export default BetaChip;
